import * as React from "react"

import "./src/styles/global.css"
// import "firebase/auth"

import { StoreProvider } from "./src/context/store"
const Layout = require("./src/layouts/Layout").default

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)
